import loadable from '@loadable/component';

import { BoxIndicator } from '@classtinginc/design-system';

const WriteAssignmentPage = loadable(() => import('./WriteAssignmentPage'), {
  fallback: <BoxIndicator />,
});

export default WriteAssignmentPage;
